import React from "react";
import { Menu } from "semantic-ui-react";
import MenuSearch from "./MenuSearch";

type SimpleListSearchProps = {
  onSearch: Function;
  onCreate: Function;
  title: string;
  createText: string;
  searchPlaceholder: string;
  text: string;
};
const SimpleListSearch = ({
  onSearch,
  onCreate,
  title,
  createText,
  searchPlaceholder,
  text,
}: SimpleListSearchProps) => {
  return (
    <Menu fluid stackable>
      <Menu.Item header>{title}</Menu.Item>
      <Menu.Item icon='plus' onClick={() => onCreate()} name={createText} />
      <Menu.Menu position='right'>
        <MenuSearch
          placeholder={searchPlaceholder}
          onSearch={(value: string) => onSearch(value)}
          value={text}
        />
      </Menu.Menu>
    </Menu>
  );
};

export default SimpleListSearch;
